import { Button, Form, Input } from 'antd';
import React, { useRef } from 'react';
import { useAuthors } from './AuthorsState';

function Add() {
    const formRef = useRef();
    let { addCat } = useAuthors()
    
    const handleFinish = (values) => {
        addCat(values);
        formRef.current?.resetFields();
    }
    
    return (
        <Form
            ref={formRef}
            name="basic"
            labelCol={{
                span: 24,
            }}
            wrapperCol={{
                span: 24,
            }}
            onFinish={handleFinish}
            autoComplete="off"
        >
            <Form.Item
                label="Avtor nomi"
                name="fullname"
                rules={[
                    {
                        required: true,
                        message: "Iltimos to'ldiring!",
                    },
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">
                    Saqlash
                </Button>
            </Form.Item>

        </Form>
    );
}

export default Add;